<button mat-icon-button (click)="toggleDrawer()" [class.shake]="shakeState" #changesOrigin>
  <mat-icon [svgIcon]="'mat_outline:history'"></mat-icon>
</button>

<fuse-drawer
  class="w-screen min-w-screen sm:w-140 sm:min-w-140 z-999"
  fixed
  [mode]="'over'"
  [name]="'changesDrawer'"
  [position]="'right'"
  #changesDrawer>

  <div class="flex flex-col w-full overflow-auto bg-gray-100 dark:bg-slate-900">
    <div class="flex flex-row items-center px-6 h-20 min-h-20 text-on-primary bg-primary">
      <mat-icon class="icon-size-7 text-current" [svgIcon]="'mat_outline:history'"></mat-icon>
      <div class="ml-3 text-2xl font-semibold tracking-tight">{{ 'systemChanges.title' | transloco }}</div>
      <button class="ml-auto" mat-icon-button (click)="changesDrawer.close()">
        <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
      </button>
    </div>
    <div class="flex flex-col p-6">
      @if (systemChanges.length > 0) {
        @for (change of systemChanges; track change; let i = $index) {
          <fuse-card class="flex flex-col px-8 py-6 pb-4">
            <div class="text-lg font-bold">{{ change.title }}</div>
            <div class="mt-1 text-sm text-hint">
              {{ 'systemChanges.' + change.type | transloco }} ({{ change.date | localizeDate: 'dd/MM/yyyy' }})
            </div>
            @if (change.description) {
              <div class="mt-2">
                {{ change.description }}
              </div>
            }
            @if (role?.systemConfig && change.issues?.length > 0) {
              <div class="mt-2">
                @for (issue of change.issues; track issue) {
                  <div class="flex">
                    <a [href]="'https://constant-tech.atlassian.net/browse/' + issue" target="_blank" class="text-blue-600">
                      {{ issue }}
                    </a>
                  </div>
                }
              </div>
            }
            <!-- <div class="flex">
            <span class="font-semibold mr-1">{{ change.title }}</span>
            <span> - {{ 'systemChanges.' + change.type | transloco }}</span>
          </div>
          <div>
            {{ change.description }}
          </div> -->
        </fuse-card>
        <hr class="my-2">
      }
    } @else {
      <h3 class="text-center p-4">{{ 'systemChanges.noItems' | transloco }}</h3>
    }
  </div>
</div>
</fuse-drawer>

<ng-template #alertChangesPanel>
  <div class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-140 sm:w-140 sm:rounded-2xl overflow-hidden shadow-lg">
    <!-- Header -->
    <div class="flex shrink-0 items-center justify-between py-4 pr-4 pl-6 bg-primary text-on-primary">
      <div class="text-lg font-medium leading-10">{{ 'systemChanges.alert' | transloco }}</div>
      <div class="-ml-1 mr-3">
        <button mat-icon-button (click)="closePanel()">
          <mat-icon class="icon-size-5 text-on-primary" [svgIcon]="'heroicons_solid:x'"></mat-icon>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto px-6 py-2 bg-card">
      <fuse-alert [type]="'info'" [appearance]="'border'">
        <span class="flex items-center justify-between" fuseAlertTitle>
          {{ 'systemChanges.alertTitle' | transloco }}
        </span>
        <div class="whitespace-pre-line" fuseAlertMessage>
          {{ 'systemChanges.alertMessage' | transloco }}
        </div>
      </fuse-alert>
    </div>
  </div>
</ng-template>

